import { Spinner } from "@/components/ui/spinner";
import { ProfileCompleteCard } from "./profile-complete-card";
import { PendingAppointmentsCard } from "./pending-appointments-card";
import { UpcomingAppointmentsCard } from "./upcoming-appointments-card";
import { useProfileComplete } from "../api/get-profile-complete";
import { useAppointments } from "../api/get-appointments";
import { useMfa } from "@/api/check-mfa";

export const DashboardCards = () => {
    const { data: profileComplete, isLoading } = useProfileComplete();
    const { data: smsFactor, isLoading: smsLoading } = useMfa();

    const items = [
        {
            id: 1,
            title: "Profile photo",
            link: "/clinician/manage",
            complete: profileComplete?.profilePhoto,
        },
        {
            id: 2,
            title: "Personal details",
            link: "/clinician/manage",
            complete: profileComplete?.personalComplete,
        },
        {
            id: 3,
            title: "Practice details",
            link: "/clinician/manage",
            complete: profileComplete?.practiceComplete,
        },
        {
            id: 4,
            title: "Multi-factor authentication",
            link: "/clinician/manage/account",
            complete: smsFactor ? 1 : 0,
        },
        {
            id: 5,
            title: "Verification",
            link: "/clinician/manage",
            complete: profileComplete?.verified,
        },
        {
            id: 6,
            title: "Services",
            link: "/clinician/services",
            complete: profileComplete?.servicesComplete,
        },
        {
            id: 7,
            title: "Availability",
            link: "/clinician/availability",
            complete: profileComplete?.availabilityComplete,
        },
    ];

    const totalAmount = items.length;
    const amountCompleted = items.filter((item) => item.complete === 1).length;

    const { data: appointments, isLoading: appointmentsLoading } =
        useAppointments({
            enabled: amountCompleted === totalAmount,
        });

    if (isLoading || appointmentsLoading || smsLoading) {
        return (
            <div className="relative">
                <div className="absolute inset-0 z-10 py-10">
                    <div className="grid h-75 place-items-center">
                        <Spinner size="lg" />
                    </div>
                </div>
            </div>
        );
    }

    if (amountCompleted < totalAmount) {
        return (
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-full md:col-span-6">
                    <ProfileCompleteCard
                        items={items}
                        totalAmount={totalAmount}
                        amountCompleted={amountCompleted}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-12 gap-4">
            <div className="col-span-full md:col-span-6">
                <UpcomingAppointmentsCard appointments={appointments} />
            </div>
            <div className="col-span-full md:col-span-6">
                <PendingAppointmentsCard appointments={appointments} />
            </div>
        </div>
    );
};
